import { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import fleetApi from '../../services/api.service';

export default function useGetTourPlanningDetails() {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);
  const abortRef = useRef(null);

  useEffect(() => {
    return () => {
      abortRef.current?.abort();
    };
  }, []);

  const fetchDetails = async (tourPlanningId) => {
    if (!tourPlanningId) return;

    abortRef.current?.abort();
    const controller = new AbortController();
    abortRef.current = controller;

    setIsLoading(true);
    setData(null);

    try {
      const response = await fleetApi.get(
        `/tours-planning/${tourPlanningId}/details`,
        { signal: controller.signal }
      );

      if (!controller.signal.aborted && response.status === 200) {
        setData(response.data);
      }
    } catch (error) {
      if (controller.signal.aborted) return;

      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          'Impossible de charger les détails.'
      );
    } finally {
      if (!controller.signal.aborted) {
        setIsLoading(false);
      }
    }
  };

  const reset = () => {
    abortRef.current?.abort();
    setData(null);
    setIsLoading(false);
  };

  return {
    isLoading,
    data,
    fetchDetails,
    reset,
  };
}
